import { useTranslation } from 'react-i18next';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Box, Button, CircularProgress, Grid2 } from '@mui/material';

const ActionButtons = ({ handleSubmit = () => {}, handleBack = () => {}, submitting = false, disabledNext = false }) => {
    const { t: translate } = useTranslation();

    return (
        <Grid2 container justifyContent="center" alignItems="center" gap="32px" mt="32px" flexWrap="nowrap">
            <Button
                sx={{
                    border: '1px solid #13131340',
                    color: '#131313',
                    width: '100%',
                    textTransform: 'none',
                    fontWeight: 700,
                    py: '8px',
                }}
                disabled={submitting}
                startIcon={<ArrowBack />}
                variant="outlined"
                onClick={handleBack}
            >
                {translate('price_group_wizard.action_buttons.back')}
            </Button>
            <Button
                sx={{
                    backgroundColor: 'var(--color-utriper-blue)',
                    width: '100%',
                    color: 'white',
                    textTransform: 'none',
                    fontWeight: 700,
                    py: '8px',
                }}
                disabled={disabledNext}
                endIcon={<ArrowForward />}
                loading={submitting}
                loadingIndicator={
                    <Box sx={{ display: 'flex' }}>
                        <CircularProgress size={20} sx={{ color: '#131313bf' }} />
                    </Box>
                }
                type="submit"
                variant="contained"
                onClick={handleSubmit}
            >
                {translate('price_group_wizard.action_buttons.next')}
            </Button>
        </Grid2>
    );
};

export default ActionButtons;
